import { FC } from 'react';

import { useCarbonScore } from '@/domains/sustainability/carbonScore/hooks/useCarbonScore';

import { CarbonScoreDetail } from './CarbonScoreDetail.lazy';

interface Props {
  className?: string;
  anchorId?: string;
  rootContainer?: React.ElementType;
}

export const CarbonScoreDetailContainer: FC<Props> = ({
  className,
  anchorId,
  rootContainer,
}) => {
  const carbonScore = useCarbonScore();

  if (!carbonScore) {
    return null;
  }

  return (
    <CarbonScoreDetail
      className={className}
      anchorId={anchorId}
      rootContainer={rootContainer}
      carbonScore={carbonScore}
    />
  );
};
